import { FC, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import SubButton from 'components/floatingactions/SubButton';
import { OfferActivationModalDatePicker } from 'components/form/input/DateInput';

import { Backend } from 'api/endpoints';

import useOfferActivate from 'hooks/useOfferActivate';
import useToggleOfferActive from 'hooks/useToggleOfferActive';

type Props = {
	id: string;
	isActive: boolean;
	employmentTypes: Backend.EmploymentType[];
};

const ToggleOfferAction: FC<Props> = ({ id, isActive, employmentTypes }) => {
	const { t } = useTranslation('components/tiles/offer_search_item/');
	const [validTo, setValidTo] = useState((null as unknown) as string);
	const [modal, openModal] = useState(false);
	const disabledTitle = useOfferActivate(employmentTypes);
	const toggleOfferActive = useToggleOfferActive(isActive, id, validTo);

	return (
		<>
			<SubButton
				icon={
					isActive ? (
						<FaEyeSlash size={15} color="white" />
					) : (
						<FaEye size={15} color="white" />
					)
				}
				size={35}
				tooltip={isActive ? t('deactivate') : t('activate')}
				onClick={isActive ? toggleOfferActive : () => openModal(true)}
				disabled={!isActive && !!disabledTitle}
				backgroundColor={isActive ? 'error' : 'primary'}
				title={!isActive ? disabledTitle : undefined}
			/>

			{modal && (
				<OfferActivationModalDatePicker
					setValidTo={setValidTo}
					validTo={validTo}
					activate={toggleOfferActive}
					closeModal={() => openModal(false)}
				/>
			)}
		</>
	);
};

export default ToggleOfferAction;
